import { Estimate } from './../../../models';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { GenericService } from 'src/app/generic.service';
import { AppConfig } from 'src/app/shared/app.config';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-out-estimate-pdf-dialog',
  templateUrl: './out-estimate-pdf-dialog.component.html',
  styles: [
  ]
})
export class OutEstimatePdfDialogComponent implements OnInit {
 estimate = new Estimate();
 uloading = false;
 apiUrl = AppConfig.settings.ApiUrl;
 @ViewChild('pdfViewer') public pdfViewer;

 constructor(public dialogRef: MatDialogRef<OutEstimatePdfDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private service: GenericService, private http: HttpClient) {
    this.estimate = ddata.estimate;
  }

  ngOnInit(): void {
    this.getInvoicePdf();
  }

  close(): void {
    this.dialogRef.close(true);
  }

  getInvoicePdf() {
    // this.signalrListner();
     let url = this.apiUrl + 'authority/GetInvoicePdfForAuthority/' + this.estimate.invoice.uid;
     this.downloadFile(url).subscribe(
       (res) => {
         // const file = new Blob([res], { type: 'application/pdf' });
 
         this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
         this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf
       }
     );
   }

   private downloadFile(url: string): any {
    return this.http.get(url, { responseType: 'blob' }).pipe(
        map((result: any) => {
          return result;
        })
      );
  }


}
